var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLifesaver2 = function SvgLifesaver2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "lifesaver-2_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h48v48H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#lifesaver-2_svg__a)",
    fill: "#004152"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.25 4.5C12.895 4.5 4.5 12.895 4.5 23.25S12.895 42 23.25 42 42 33.605 42 23.25 33.605 4.5 23.25 4.5ZM2 23.25C2 11.514 11.514 2 23.25 2S44.5 11.514 44.5 23.25 34.986 44.5 23.25 44.5 2 34.986 2 23.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.25 12.5c-5.937 0-10.75 4.813-10.75 10.75S17.313 34 23.25 34 34 29.187 34 23.25 29.187 12.5 23.25 12.5ZM10 23.25C10 15.932 15.932 10 23.25 10S36.5 15.932 36.5 23.25 30.568 36.5 23.25 36.5 10 30.568 10 23.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.04 11.156 5.632 5.682 4.262-4.223-5.632-5.682-4.261 4.223ZM11.156 39.46l5.682-5.632-4.223-4.262-5.682 5.631 4.223 4.262ZM33.885 16.934l5.683-5.632-4.224-4.261-5.682 5.631 4.223 4.262ZM29.566 33.885l5.631 5.682 4.262-4.223-5.631-5.682-4.262 4.223Z"
  }))));
};
export default SvgLifesaver2;